import { DrawCustomModeThis, DrawFeature, DrawLineString, DrawPoint } from "@mapbox/mapbox-gl-draw";

import { ValidationState } from "fond/draw/validation/helper";
import { EditingLayer } from "fond/types";

import { deleteAndValidate, getFeatureId, getLineEndpointPoints, NodeTopologyConfig, pullInFeatures } from "../topologyHelper";

import { aerialConfig } from "./helper";

/**
 * Makes the aerial delete handler.
 *
 * Deleting a pole cascades to the spans connected to it; deleting a span leaves its
 * poles in place but refreshes their snapped status.
 *
 * Designed to be used as an EditingLayer.onTrash callback.
 */
export const makeOnTrashAerial = (config: NodeTopologyConfig): NonNullable<EditingLayer["onTrash"]> =>
  function onTrashAerial(this: DrawCustomModeThis, features: DrawFeature[], state: ValidationState): void {
    const deleteIds: (string | number)[] = [];
    const polesToRefresh: DrawPoint[] = [];

    features.forEach((feature) => {
      if (feature.id != null) {
        deleteIds.push(feature.id);
      }

      if (feature.type === "Point") {
        const { lines: spans } = pullInFeatures.call(this, config, feature);
        deleteIds.push(...spans.map((span) => getFeatureId(span)).filter((id): id is string | number => id != null));
      } else if (feature.type === "LineString") {
        polesToRefresh.push(...getLineEndpointPoints.call(this, config, feature as DrawLineString));
      }
    });

    deleteAndValidate.call(this, config, state, deleteIds, polesToRefresh);
  };

/**
 * Aerial delete handler bound to the planner span/pole layers.
 */
export const onTrashAerial = makeOnTrashAerial(aerialConfig);
